import { Field, ID, ObjectType } from 'type-graphql'

/**
 * We can use this as the type for options, and the class below is for data transfer object purpose
 */
export interface IOption {
  _id?: string
  value: string
  label: string
}

@ObjectType()
export class Option implements IOption {
  @Field(() => ID)
  _id?: string

  @Field(() => String, { nullable: true })
  value: string

  @Field(() => String, { nullable: true })
  label: string
}
